export const TITLE =
  'Anschreiben, Lebenslauf & Co: Tipps für eine erfolgreiche Bewerbung';
